import { useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "@/data/site";

const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = TESTIMONIALS[i];
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);

  return (
    <section className="bg-crest-green-100/40 border-y border-border" data-testid="testimonials-section">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28">
        <div className="flex items-center justify-between gap-8">
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-crest-gold font-medium">In their own words</p>
            <h2 className="mt-2 font-display text-3xl md:text-5xl font-bold text-crest-navy">What our clients say</h2>
          </div>
          <div className="hidden md:flex gap-2">
            <button onClick={prev} className="h-11 w-11 rounded-md border border-crest-navy/15 grid place-items-center hover:bg-white hover:border-crest-green transition-colors duration-200" aria-label="Previous testimonial" data-testid="testimonials-prev">
              <ChevronLeft className="h-5 w-5 text-crest-navy" />
            </button>
            <button onClick={next} className="h-11 w-11 rounded-md border border-crest-navy/15 grid place-items-center hover:bg-white hover:border-crest-green transition-colors duration-200" aria-label="Next testimonial" data-testid="testimonials-next">
              <ChevronRight className="h-5 w-5 text-crest-navy" />
            </button>
          </div>
        </div>

        <div className="mt-10 grid md:grid-cols-12 gap-8 items-end" key={i}>
          <div className="md:col-span-9 animate-fade-up">
            <Quote className="h-10 w-10 text-crest-gold" />
            <blockquote className="mt-6 font-display text-2xl md:text-3xl leading-snug text-crest-navy max-w-3xl">
              "{t.quote}"
            </blockquote>
            <div className="mt-8 flex items-center gap-4">
              <div className="h-12 w-12 rounded-full bg-crest-green text-white grid place-items-center font-display text-lg">
                {t.name.split(" ").map((n) => n[0]).join("").slice(0,2)}
              </div>
              <div>
                <div className="font-display text-base font-semibold text-crest-navy">{t.name}</div>
                <div className="text-sm text-muted-foreground">{t.role}</div>
              </div>
            </div>
          </div>
          <div className="md:col-span-3 flex md:flex-col gap-2">
            {TESTIMONIALS.map((tItem, idx) => (
              <button
                key={tItem.name}
                onClick={() => setI(idx)}
                aria-label={`Go to testimonial ${idx + 1}`}
                data-testid={`testimonial-dot-${idx}`}
                className={`h-1.5 md:h-1.5 md:w-full flex-1 rounded-full transition-colors duration-200 ${idx === i ? "bg-crest-green" : "bg-crest-navy/15 hover:bg-crest-navy/30"}`}
              />
            ))}
          </div>
        </div>

        <div className="md:hidden mt-8 flex justify-center gap-3">
          <button onClick={prev} className="h-11 w-11 rounded-md border border-crest-navy/15 grid place-items-center" aria-label="Previous"><ChevronLeft className="h-5 w-5" /></button>
          <button onClick={next} className="h-11 w-11 rounded-md border border-crest-navy/15 grid place-items-center" aria-label="Next"><ChevronRight className="h-5 w-5" /></button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
